import { useQuery } from "@tanstack/react-query";
import crashBundlesClient from "../../../api/crashBundles";

/**
 * Lists crash bundles. With a clockId it searches the bucket by prefix; otherwise it
 * returns the 10 most recent.
 */
const useCrashBundlesQuery = (clockId: string) =>
  useQuery({
    queryKey: ["crash-bundles", clockId],
    queryFn: () =>
      clockId
        ? crashBundlesClient.searchByClockId(clockId)
        : crashBundlesClient.getLatest(),
  });

export default useCrashBundlesQuery;
